import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';

Vue.use(Vuex)

// const key = "!lol-laughing101?@ITKmITlisDAbest.i39Ga917gkiBq4KtugbmoX94bkyTcQsd0xITECmUfVk3p3EclHCVed"

let store = new Vuex.Store({
  state: {
    profile: {
      username: "",
      password: "",
      name: "",
      surname: "",
      token: "",
      role: ""
    }
  },
  plugins: [createPersistedState({
    key: 'ophkmitl',
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 2, secure: false, }),
      removeItem: key => Cookies.remove(key)
    },
  })],
  getters: {
    getUsername: (state) => {
      return state.profile.username
    },
    getPassword: (state) => {
      return state.profile.password
    },
    getName: (state) => {
      return state.profile.name
    },
    getSurname: (state) => {
      return state.profile.surname
    },
    getRole: (state) => {
      return state.profile.role
    },
    getToken: (state) => {
      return state.profile.token
    },
    getLoginState: (state) => {
      return state.profile.username != null && state.profile.username != "" &&
             state.profile.password != null && state.profile.password != ""
    }
  },
  mutations: {
    setUsername(state, user) {
      state.profile.username = user
    },
    setPassword(state, pass) {
      state.profile.password = pass
    },
    setName(state, name) {
      state.profile.name = name
    },
    setSurname(state, surname) {
      state.profile.surname = surname
    },
    setRole(state, role) {
      state.profile.role = role
    },
    setToken(state, token) {
      state.profile.token = token
    },
    clearState(state) {
      state.profile.username = ""
      state.profile.password = ""
      state.profile.name = ""
      state.profile.surname = ""
      state.profile.role = ""
      state.profile.token = ""

      let cookies = document.cookie.split(";")
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i]
        if (cookie === "ophkmitl") {
          let eqPos = cookie.indexOf("=")
          let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
          break
        }
      }
    },
    checkLogin(state) {
      return state.profile.username != null && state.profile.username != "" &&
             state.profile.password != null && state.profile.password != ""
    },
  },
  actions: {
    login({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        if (payload.username == null || payload.password == null) reject("Missing arguments")
        else {
            axios({
              method: "POST",
              url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/auth/login",
              headers: {
                "Content-Type": "application/json"
              },
              data: {
                "username": payload.username,
                "password": payload.password,
              }
            })
            .then((res) => {
              // console.log(res.data)
              if (res.data.message === "Login fail") {
                reject(res)
              } else {
                // console.log(state)
                let res_ = {
                  username: payload.username,
                  password: payload.password,
                  name: res.data.name,
                  surname: res.data.surname,
                  token: res.data.token,
                  message: res.data.message
                }
                commit("setUsername", res_.username)
                commit("setPassword", res_.password)
                commit("setName", res_.name)
                commit("setSurname", res_.surname)
                commit("setToken", res_.token)
                resolve(res_)
              }
            })
            .catch((err) => {
              reject(err)
            })
          }
      })
    }
  }
})

export default store